/**
 * cleanAvatarUrl — turn a stored employee PictureUrl into something safe to put in <img src>.
 *
 * WHY: teamio.employees.PictureUrl often holds the literal STRING "null" (and sometimes "" or
 * "undefined"). Those are truthy, so `PictureUrl || null` let them through, notifications stored
 * them, and <img src="null"> rendered as a broken image in the header bell dropdown (2026-09-27).
 *
 * Pure and import-free ON PURPOSE — cypress/node-tests/notification-avatar-url.test.js loads and
 * executes this exact file. Keep it that way.
 */

const JUNK = ['null', 'undefined'];

/** @returns {string|null} the trimmed URL, or null when there is no usable value. */
export function cleanAvatarUrl(url) {
    if (typeof url !== 'string') return null;
    const s = url.trim();
    if (!s || JUNK.includes(s.toLowerCase())) return null;
    return s;
}
